<template>
    <common-modal
        :heading="$t('modals.add_availability.heading')"
        headingCenter="true"
        width="huge"
        height="medium"
        :padding="isSmartphone"
        @close="emitEvent({ name: 'close' })"
        @modal-dimensions="emittedEventResult"
    >
        <common-page-plain :padding="isSmartphone">
            <common-content-wrapper width="huge">
                <add-availability-form
                    :query="query"
                    :modalDimensions="modalDimensions"
                    @success="emitEvent({ name: 'success' })"
                    @close="emitEvent({ name: 'close' })"
                ></add-availability-form>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    import AddAvailabilityForm from 'components/forms/availability/AddAvailabilityForm'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],
        components: { AddAvailabilityForm },
        props: {
            query: { type: Object, default: undefined },
        },

        data() {
            return {
                modalDimensions: null,
            }
        },

        computed: {
            isSmartphone() {
                return this.isSmartphoneLarge ? 'none' : undefined
            },
        },

        methods: {
            emittedEventResult(payload) {
                this.modalDimensions = payload
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    @include breakpoint(smartphone-large) {
        .page-plain {
            padding: 15px !important;
            border: 0;
        }
    }
</style>
